import { AppLayout } from '@/components/layout/AppLayout'

export interface PageShellProps {
  /** Page content */
  children: React.ReactNode
  /** Additional CSS classes */
  className?: string
}

/**
 * Main layout wrapper — delegates to AppLayout (sidebar + topbar).
 * Kept as a thin wrapper so existing page imports continue to work.
 */
export function PageShell({ children, className }: PageShellProps) {
  return (
    <AppLayout className={className}>
      {children}
    </AppLayout>
  )
}
